import React from 'react';
import { UserCircleIcon, LockClosedIcon, SpinnerIcon } from '../../../components/Icons';
import { CIEN_CUADRAS_BUTTON_BLUE } from '../../../constants';

interface SignInFormProps {
  email: string;
  setEmail: (val: string) => void;
  pass: string;
  setPass: (val: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onForgotPassword: () => void;
  onSwitchToSignUp: () => void;
  isLoading: boolean;
}

export const SignInForm: React.FC<SignInFormProps> = ({
  email,
  setEmail,
  pass,
  setPass,
  onSubmit,
  onForgotPassword,
  onSwitchToSignUp,
  isLoading,
}) => {
  const canSubmit = email.trim() !== '' && pass.trim() !== '';

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label htmlFor="signInEmail" className="sr-only">Correo Electrónico</label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <UserCircleIcon className="h-5 w-5 text-gray-400" />
          </div>
          <input
            id="signInEmail"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="appearance-none block w-full px-3 py-2 pl-10 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            placeholder="Correo Electrónico"
            disabled={isLoading}
          />
        </div>
      </div>

      <div>
        <label htmlFor="signInPassword" className="sr-only">Contraseña</label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <LockClosedIcon className="h-5 w-5 text-gray-400" />
          </div>
          <input
            id="signInPassword"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            className="appearance-none block w-full px-3 py-2 pl-10 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            placeholder="Contraseña"
            disabled={isLoading}
          />
        </div>
      </div>

      <div className="text-right">
        <button
          type="button"
          onClick={onForgotPassword}
          className="text-xs font-semibold text-sky-700 hover:underline focus:outline-none"
        >
          ¿Olvidaste tu contraseña?
        </button>
      </div>

      <button
        type="submit"
        disabled={isLoading || !canSubmit}
        className="w-full flex items-center justify-center py-2.5 px-4 rounded-md shadow-sm text-base font-semibold text-white transition-opacity disabled:opacity-60"
        style={{ backgroundColor: CIEN_CUADRAS_BUTTON_BLUE }}
      >
        {isLoading ? <SpinnerIcon className="w-5 h-5 text-white mr-2" /> : null}
        Iniciar Sesión
      </button>

      <div className="text-center pt-2">
        <p className="text-xs text-gray-600">
          ¿No tienes una cuenta de Broker?{' '}
          <button
            type="button"
            onClick={onSwitchToSignUp}
            disabled={isLoading}
            className="font-bold text-sky-700 hover:underline focus:outline-none"
          >
            Crear una Cuenta
          </button>
        </p>
      </div>
    </form>
  );
};
